import $ from 'jquery'
import {actionSelect} from './selector'
import {Core} from "./core.js";

export class Hubspot {

  constructor() {
    this.urlStyle = window.location.protocol + '//' + window.location.hostname + '/wp-content/themes/cegid-redesign/assets/dist/styles/hubspot.css'
    this.classes = {
      stylised: 'hubspot-form-stylised'
    }
    this.$body = $('body')

    $(document).ready(this.init.bind(this))

    if (! Core.isAdmin()) {
      this.$body.on('DOMSubtreeModified', this.init.bind(this))
    }
  }

  init() {
    let iframesHubspot = $(`.hs-form-iframe:not(.${this.classes.stylised})`)

    if (iframesHubspot.length > 0) {
      iframesHubspot.each(this.styliseIframe.bind(this))
    }

    let formsHubspot = $(`.hbspt-form form:not(.${this.classes.stylised})`)

    if (formsHubspot.length > 0) {
      formsHubspot.each(this.styliseForm.bind(this))

      this.addStyleToHead()
    }
  }

  styliseIframe(index, iframe) {
    let $iframe = $(iframe)

    $iframe.addClass(this.classes.stylised)

    let $iframeHead = $iframe.contents().find('html head')

    $.get(this.urlStyle, (style) => {
      let cssLink = $('<style>', {
        type: 'text/css',
        id: 'cegid-hubspot-iframe-css',
      })
      cssLink.text(style)
      $iframeHead.append(cssLink)
    })

    if (this.$body.find('#Prod-js')) {
      $iframeHead.append(this.$body.find('#Prod-js').clone())
    } else if (this.$body.find('#Dev-js')) {
      $iframeHead.append(this.$body.find('#Dev-js').clone())
    }
  }

  styliseForm(index, form) {
    let $form = $(form)

    $form.addClass(this.classes.stylised)

    // Generate fake select
    $form.find('select').each(actionSelect)
  }

  addStyleToHead() {
    if ($('#cegid-hubspot-css').length > 0) {
      return
    }

    $.get(this.urlStyle, (style) => {
      let cssLink = $('<style>', {
        type: 'text/css',
        id: 'cegid-hubspot-css',
      })
      cssLink.text(style)
      $('html > head').append(cssLink)
    })
  }
}

